export default {
    bell: 0,
    newNotification: [],
    isInAppSoundEnabled: null,
    ws: null
}